const keyFor = (clientType, resource) => `assignx:${String(clientType || 'default')}:${resource}`;

function read(clientType, resource) {
  try {
    return JSON.parse(localStorage.getItem(keyFor(clientType, resource)) || '[]');
  } catch (_) {
    return [];
  }
}

function write(clientType, resource, rows) {
  localStorage.setItem(keyFor(clientType, resource), JSON.stringify(rows));
  return rows;
}

export const listLocalScenarios = (clientType) => read(clientType, 'scenarios');

export function saveLocalScenario(clientType, name, definition, lastResultSummary) {
  const rows = listLocalScenarios(clientType);
  const duplicate = rows.find((row) => row.name.toLowerCase() === name.toLowerCase());
  if (duplicate) throw new Error('Nome scenario già esistente');
  const now = new Date().toISOString();
  const row = {
    id: `local-${Date.now()}`,
    client_type: clientType,
    name,
    definition,
    last_method: 'kpath_bpr_msa',
    last_result_summary: lastResultSummary || null,
    created_at: now,
    updated_at: now,
    local: true,
  };
  write(clientType, 'scenarios', [row, ...rows]);
  return row;
}

export function updateLocalScenario(clientType, id, name, definition, lastResultSummary) {
  const rows = listLocalScenarios(clientType);
  const index = rows.findIndex((row) => String(row.id) === String(id));
  if (index < 0) throw new Error('Scenario locale non trovato');
  const duplicate = rows.find(
    (row) => String(row.id) !== String(id) && row.name.toLowerCase() === name.toLowerCase(),
  );
  if (duplicate) throw new Error('Nome scenario già esistente');
  const updated = {
    ...rows[index],
    name,
    definition,
    last_result_summary: lastResultSummary || null,
    updated_at: new Date().toISOString(),
  };
  write(clientType, 'scenarios', [updated, ...rows.filter((_, rowIndex) => rowIndex !== index)]);
  return updated;
}

export function deleteLocalScenario(clientType, id) {
  write(
    clientType,
    'scenarios',
    listLocalScenarios(clientType).filter((row) => String(row.id) !== String(id)),
  );
}

export const listLocalRoads = (clientType) => read(clientType, 'new-roads');

export function saveLocalRoad(clientType, road) {
  const rows = listLocalRoads(clientType);
  const id = String(road.temp_id || road.uid);
  const saved = { ...road, temp_id: id, uid: id, local: true };
  write(clientType, 'new-roads', [saved, ...rows.filter((row) => String(row.temp_id || row.uid) !== id)]);
  return saved;
}

export function deleteLocalRoad(clientType, id) {
  write(
    clientType,
    'new-roads',
    listLocalRoads(clientType).filter((road) => String(road.temp_id || road.uid) !== String(id)),
  );
}

export function canUseLocalFallback(error) {
  return !error?.status || [404, 405, 501].includes(error.status);
}

/**
 * True only when the server answered that the endpoint does not exist.
 * A timeout or a dropped connection means "unknown", not "missing", so it must
 * never disable an endpoint for the rest of the session.
 */
export function isEndpointUnavailable(error) {
  return [404, 405, 501].includes(error?.status);
}
